import { render, staticRenderFns } from "./MiniBarChart.vue?vue&type=template&id=4b1e38b1"
import script from "./MiniBarChart.vue?vue&type=script&lang=js"
export * from "./MiniBarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports